import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Spinner } from 'reactstrap';

// The app's buttons (OQ-181, decisions/0011-web-app-design-language.md, ui/app-components.md § Shared UI components).
// accent and inverse are for the dark top bar only.
export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'danger-ghost' | 'accent' | 'inverse';

export const variantClass: Record<ButtonVariant, string> = {
  primary: 'btn-primary',
  secondary: 'btn-fe-secondary',
  ghost: 'btn-fe-ghost',
  danger: 'btn-danger',
  'danger-ghost': 'btn-fe-danger-ghost',
  accent: 'btn-fe-accent',
  inverse: 'btn-fe-inverse'
};

export type AppButtonProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & {
  variant?: ButtonVariant;
  size?: 'sm';
  icon?: IconProp;
  loading?: boolean;
  // A toggle that is on (a set filter): Bootstrap's active class.
  active?: boolean;
  children?: React.ReactNode;
  ref?: React.Ref<HTMLButtonElement>;
};

export const AppButton = ({
  variant = 'secondary',
  size,
  icon,
  loading,
  active,
  className,
  disabled,
  type = 'button',
  children,
  ...rest
}: AppButtonProps) => (
  <button
    type={type}
    className={['btn', variantClass[variant], size === 'sm' && 'btn-sm', active && 'active', className]
      .filter(Boolean)
      .join(' ')}
    disabled={disabled || loading}
    {...rest}
  >
    {loading ? <Spinner size='sm'>{''}</Spinner> : icon && <FontAwesomeIcon icon={icon} />}
    {children}
  </button>
);
